
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"20","viewBox":"0 -960 960 960","width":"20","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M480.28-260q-91.82 0-156.05-63.96Q260-387.91 260-479.72q0-91.82 63.96-156.05Q387.91-700 479.72-700q91.82 0 156.05 63.96Q700-572.09 700-480.28q0 91.82-63.96 156.05Q572.09-260 480.28-260z"}})])
          )
        }
      }
    